var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#afterpay--8FJAB';
                    var viewUrl = 'sprites.svg#view-afterpay--8FJAB';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 104 36',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };